import { Link } from "@tanstack/react-router";

import Badge from "../components/badge";
import type { BadgeType } from "../types";

interface BadgesProps {
  badges: BadgeType[];
  count: number;
  username: string;
}

export default function Badges({ badges, count, username }: BadgesProps) {
  return (
    <div className="flex flex-col items-stretch gap-5">
      <div className="flex items-center justify-between">
        <h3 className="font-medium text-18/[1.5em] text-white">
          Badges ({count})
        </h3>
        <Link className="text-14 hover:underline" to={`/@${username}/badges`}>
          See all &gt;
        </Link>
      </div>
      <div className="grid grid-cols-4 gap-5 md:grid-cols-3 md:gap-[11px]">
        {badges.map((badge) => (
          <Badge badge={badge} key={badge.id} />
        ))}
      </div>
    </div>
  );
}
